<template>
  <el-tabs
    class="routerTop"
    v-model="dataMark"
    @tab-click="goToPage"
  >
    <el-tab-pane
      v-for="item in menuArr"
      :label="$t(`lang.${item.name}`)"
      :name="item.dataMark"
      :key="item.dataMark"
    >
      <span
        slot="label"
        v-if="item.dataMark == 'hmn'">
        {{$t(`lang.${item.name}`)}}
        <svg
          class="icon"
          aria-hidden="true"
          style="height: 12px;width: 24px;margin-bottom: 8px;">
          <use :xlink:href="dataMark == 'hmn'? '#icon-a-newselected' : '#icon-a-newunselected'"></use>
        </svg>
      </span>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      menuArr: [{
        dataMark: 'hm',
        name: 'sources',
        permission: true
      }, {
        dataMark: 'mr',
        name: 'receivers',
        permission: true
      }, {
        dataMark: 'rc',
        name: 'advanceControlOption',
        permission: true
      }],
      dataMark: 'hm'
    }
  },
  methods: {
    goToPage () {
      this.$router.push({ path: `/${this.dataMark}` }).catch(() => {})
    }
  },
  computed: {
    ...mapState('common', {
      StateObj: state => state
    })
  },
  created () {
    if (this.StateObj.baseUrl.openNewSources) {
      const hmnItem = {
        dataMark: 'hmn',
        name: 'sources',
        permission: true
      }
      // 检查是否已存在相同 dataMark 的项
      const isExist = this.menuArr.some(item => item.dataMark === hmnItem.dataMark)

      // 如果不存在，则插入
      if (!isExist) {
        this.menuArr.splice(1, 0, hmnItem)
      }
    }
    this.dataMark = this.$route.path.split('/')[1]
  },
  watch: {
    $route (to, from) {
      this.dataMark = to.path.split('/')[1]
    }
  }
}
</script>
<style lang="less" scoped>
.routerTop {
  ::v-deep .el-tabs__header {
    width: 99.5%;
    padding-left: 1%;
    margin-bottom: 0;
    .el-tabs__nav .el-tabs__item {
      text-align: center;
      min-width: 100px;
    }
  }
}
</style>
